export const translations = {
  it: {
    common: {
      and: "&",
      date: "09 Agosto 2026",
      shortDate: "09.08.2026",
    },
    nav: {
      story: "La Nostra Storia",
      family: "Con noi, accanto a noi",
      program: "Programma",
      venue: "Location",
      dressCode: "Dress Code",
      rsvp: "I tuoi dati",
    },
    audio: {
      play: "Avvia musica",
      pause: "Ferma musica",
    },
    envelope: {
      title: "Natanael & Raluka",
      hint: "Apri l'invito",
      date: "09 · 08 · 2026",
    },
    curtain: {
      hint: "Apri le tende",
    },
    hero: {
      overline: "Ci sposiamo",
      subtitle: "Uniti davanti a Dio e alle persone che amiamo",
      location: "The Barn · Cluj",
      scroll: "Scorri",
    },
    countdown: {
      title: "Il conto alla rovescia",
      subtitle: "Nell'attesa",
      days: "Giorni",
      hours: "Ore",
      minutes: "Minuti",
      seconds: "Secondi",
      ended: "È il giorno",
    },
    story: {
      overline: "La nostra storia",
      title: "Due cuori, una sola strada",
      body:
        "Una storia d'amore da raccontare merita un giorno da ricordare. E se l'amore potesse riunire attorno alla stessa tavola le persone più care, voi sareste tra loro. Per questo vi abbiamo riservato con affetto un posto, per condividere una giornata fatta di sorrisi, lacrime di gioia e istanti così belli da volerli trattenere ancora un po'.",
      videoCaption: "Noi, oggi",
    },
    program: {
      overline: "Il Programma",
      title: "Il giorno del sì",
      ceremony: {
        time: "13:00",
        title: "Cerimonia Religiosa",
      },
      party: {
        time: "15:00",
        title: "Ricevimento",
      },
    },
    venue: {
      overline: "Dove",
      title: "The Barn",
      address: "Gheorghieni, nr. 530, Com. Feleacu, Jud. Cluj",
      cta: "Apri in Maps",
    },
    dressCode: {
      overline: "Dress Code",
      title: "Tonalità di rosso, marrone e nero",
      swatches: {
        burgundy: "Rosso",
        brown: "Marrone",
        black: "Nero",
      },
    },
    family: {
      overline: "Con noi, accanto a noi",
      title: "",
      groomParents: "Genitori dello Sposo",
      brideParents: "Genitori della Sposa",
      witnesses: "I Testimoni",
    },
    attention: {
      overline: "Attenzione",
      title: "Attenzione!",
      body:
        "La partecipazione a questo evento può provocare sorrisi, abbracci e ricordi che resteranno nel cuore.",
    },
    rsvp: {
      overline: "I tuoi dati",
      title: "La tua conferma",
      subtitle:
        "Ti chiediamo di confermare entro il 9 luglio 2026: ogni dettaglio ci aiuta a prenderci cura di te.",
      step: "Passo",
      of: "di",
      next: "Avanti",
      back: "Indietro",
      submit: "Invia la conferma",
      submitting: "Invio in corso...",
      attending: {
        title: "Sarai con noi?",
        yes: "Sì, ci sarò con gioia",
        no: "Purtroppo non potrò",
      },
      menu: {
        vegetarian: "Vegetariano",
        vegan: "Vegano",
      },
      allergies: {
        label: "Allergie o intolleranze",
        placeholder: "Indicaci qualsiasi cosa dovremmo sapere",
        none: "Nessuna allergia",
      },
      accommodation: {
        title: "Hai bisogno di un alloggio?",
        yes: "Sì, mi servirebbe",
        no: "No, grazie",
      },
      adults: {
        title: "Adulti",
        subtitle:
          "Per ognuno: nome, scelta del menù ed eventuali allergie",
        add: "Aggiungi adulto",
        firstName: "Nome",
        lastName: "Cognome",
        remove: "Rimuovi",
        person: "Adulto",
      },
      children: {
        title: "Bambini",
        subtitle:
          "Se ci saranno: nome, scelta del menù ed eventuali allergie",
        add: "Aggiungi bambino",
        person: "Bambino",
      },
      song: {
        title: "Un canto scelto da te",
        subtitle: "Ci piacerebbe includerlo nella playlist della serata",
        placeholder:
          "Ogni festa ha la sua musica, ma la nostra suonerà ancora meglio con qualche nota scelta da voi",
      },
      contact: {
        title: "Come possiamo contattarti",
        hint: "Indicaci almeno uno tra email e cellulare",
        email: "Email",
        phone: "Cellulare",
      },
      success: {
        title: "Grazie di cuore",
        body: "Abbiamo ricevuto la tua conferma. Non vediamo l'ora di festeggiare con te.",
        again: "Invia un'altra risposta",
      },
      errors: {
        required: "Campo obbligatorio",
        email: "Inserisci un'email valida",
        emailOrPhone: "Inserisci almeno l'email o il cellulare per poterti contattare in caso di necessità",
        needName: "Inserisci almeno un adulto con nome e cognome",
        generic: "Qualcosa è andato storto. Riprova.",
      },
    },
    footer: {
      title: "Natanael & Raluka",
      date: "09 Agosto 2026 · The Barn, Cluj",
      made: "Con amore",
      download: "Scarica l'invito",
      downloading: "Preparazione...",
    },
    admin: {
      title: "Area Riservata",
      subtitle: "Visualizza le conferme RSVP",
      tokenLabel: "Token amministratore",
      enter: "Entra",
      logout: "Esci",
      wrong: "Token non valido",
      stats: {
        total: "Conferme totali",
        attending: "Partecipano",
        notAttending: "Non partecipano",
        adults: "Adulti",
        children: "Bambini",
        accommodation: "Alloggio",
        vegan: "Vegano",
        vegetarian: "Vegetariano",
      },
      table: {
        name: "Nome",
        email: "Email",
        phone: "Cellulare",
        attending: "Presenza",
        adults: "Adulti",
        children: "Bambini",
        accommodation: "Alloggio",
        song: "Canzone",
        date: "Data invio",
        actions: "Azioni",
      },
      view: {
        confirmations: "Conferme",
        trash: "Cestino",
      },
      actions: {
        delete: "Sposta nel cestino",
        restore: "Ripristina",
        permanentDelete: "Elimina definitivamente",
        confirmDelete: "Spostare questa conferma nel cestino?",
        confirmPermanentDelete: "Eliminare DEFINITIVAMENTE questa conferma? Non potrà essere recuperata.",
      },
      trashEmpty: "Il cestino è vuoto",
      deletedAt: "Eliminato il",
    },
  },
  ro: {
    common: {
      and: "&",
      date: "09 August 2026",
      shortDate: "09.08.2026",
    },
    nav: {
      story: "Povestea noastră",
      family: "Lângă noi, cu noi",
      program: "Program",
      venue: "Locația",
      dressCode: "Ținuta",
      rsvp: "Datele tale",
    },
    audio: {
      play: "Pornește muzica",
      pause: "Oprește muzica",
    },
    envelope: {
      title: "Natanael & Raluka",
      hint: "Deschide invitația",
      date: "09 · 08 · 2026",
    },
    curtain: {
      hint: "Deschide perdelele",
    },
    hero: {
      overline: "Ne căsătorim",
      subtitle: "Uniți în fața lui Dumnezeu și a celor dragi",
      location: "The Barn · Cluj",
      scroll: "Derulează",
    },
    countdown: {
      title: "Numărătoarea inversă",
      subtitle: "În așteptare",
      days: "Zile",
      hours: "Ore",
      minutes: "Minute",
      seconds: "Secunde",
      ended: "Este ziua!",
    },
    story: {
      overline: "Povestea noastră",
      title: "Două inimi, un singur drum",
      body:
        "O poveste de dragoste frumoasă merită o zi de poveste. Iar dacă dragostea ar aduna oamenii dragi la aceeași masă, voi ați fi acolo. De aceea, noi vă păstrăm cu drag loc liber, pentru o zi plină de râsete, lacrimi de fericire și clipele acelea în care tot ce vrei e să mai rămâi puțin.",
      videoCaption: "Noi, astăzi",
    },
    program: {
      overline: "Programul",
      title: "Ziua în care ne spunem 'da'",
      ceremony: {
        time: "13:00",
        title: "Cununia Religioasă",
      },
      party: {
        time: "15:00",
        title: "Petrecerea",
      },
    },
    venue: {
      overline: "Unde",
      title: "The Barn",
      address: "Gheorghieni, nr. 530, Com. Feleacu, Jud. Cluj",
      cta: "Deschide în Maps",
    },
    dressCode: {
      overline: "Ținuta",
      title: "Nuanțe de roșu, maro și negru",
      swatches: {
        burgundy: "Roșu",
        brown: "Maro",
        black: "Negru",
      },
    },
    family: {
      overline: "Lângă noi, cu noi",
      title: "",
      groomParents: "Părinții Mirelui",
      brideParents: "Părinții Miresei",
      witnesses: "Nașii",
    },
    attention: {
      overline: "Atenție",
      title: "Atenție!",
      body:
        "Participarea la acest eveniment poate provoca zâmbete, îmbrățișări și amintiri frumoase.",
    },
    rsvp: {
      overline: "Datele tale",
      title: "Confirmarea ta",
      subtitle:
        "Te rugăm să confirmi până la 9 iulie 2026: fiecare detaliu ne ajută să ne ocupăm de tine cum se cuvine.",
      step: "Pasul",
      of: "din",
      next: "Mai departe",
      back: "Înapoi",
      submit: "Trimite confirmarea",
      submitting: "Se trimite...",
      attending: {
        title: "Vei fi alături de noi?",
        yes: "Da, voi veni cu bucurie",
        no: "Din păcate, nu pot",
      },
      menu: {
        vegetarian: "Vegetarian",
        vegan: "Vegan",
      },
      allergies: {
        label: "Alergii sau intoleranțe",
        placeholder: "Spune-ne orice am putea avea de știut",
        none: "Fără alergii",
      },
      accommodation: {
        title: "Ai nevoie de cazare?",
        yes: "Da, am nevoie",
        no: "Nu, mulțumesc",
      },
      adults: {
        title: "Adulți",
        subtitle:
          "Pentru fiecare: nume, alegerea meniului și eventualele alergii",
        add: "Adaugă adult",
        firstName: "Prenume",
        lastName: "Nume",
        remove: "Șterge",
        person: "Adult",
      },
      children: {
        title: "Copii",
        subtitle:
          "Dacă vor fi: nume, alegerea meniului și eventualele alergii",
        add: "Adaugă copil",
        person: "Copil",
      },
      song: {
        title: "Un cântec ales de tine",
        subtitle: "Ne-ar plăcea să-l includem în playlist-ul serii",
        placeholder:
          "Fiecare petrecere are muzica ei, dar a noastră va suna și mai bine cu câteva note alese de voi",
      },
      contact: {
        title: "Cum te putem contacta",
        hint: "Lasă-ne măcar emailul sau numărul de telefon",
        email: "Email",
        phone: "Telefon",
      },
      success: {
        title: "Îți mulțumim din suflet",
        body: "Am primit confirmarea ta. Abia așteptăm să sărbătorim cu tine.",
        again: "Trimite un alt răspuns",
      },
      errors: {
        required: "Câmp obligatoriu",
        email: "Introdu o adresă de email validă",
        emailOrPhone: "Introdu cel puțin emailul sau numărul de telefon ca să te putem contacta în caz de nevoie",
        needName: "Introdu cel puțin un adult cu nume și prenume",
        generic: "Ceva nu a mers. Încearcă din nou.",
      },
    },
    footer: {
      title: "Natanael & Raluka",
      date: "09 August 2026 · The Barn, Cluj",
      made: "Cu dragoste",
      download: "Descarcă invitația",
      downloading: "Se pregătește...",
    },
    admin: {
      title: "Zonă Administrator",
      subtitle: "Vizualizează confirmările RSVP",
      tokenLabel: "Token administrator",
      enter: "Intră",
      logout: "Ieși",
      wrong: "Token invalid",
      stats: {
        total: "Confirmări totale",
        attending: "Participă",
        notAttending: "Nu participă",
        adults: "Adulți",
        children: "Copii",
        accommodation: "Cazare",
        vegan: "Vegan",
        vegetarian: "Vegetarian",
      },
      table: {
        name: "Nume",
        email: "Email",
        phone: "Telefon",
        attending: "Prezență",
        adults: "Adulți",
        children: "Copii",
        accommodation: "Cazare",
        song: "Piesă",
        date: "Data trimiterii",
        actions: "Acțiuni",
      },
      view: {
        confirmations: "Confirmări",
        trash: "Coș de gunoi",
      },
      actions: {
        delete: "Mută în coș",
        restore: "Restaurează",
        permanentDelete: "Șterge definitiv",
        confirmDelete: "Muți această confirmare în coș?",
        confirmPermanentDelete: "Ștergi DEFINITIV această confirmare? Nu va mai putea fi recuperată.",
      },
      trashEmpty: "Coșul este gol",
      deletedAt: "Șters la",
    },
  },
  de: {
    common: {
      and: "&",
      date: "09. August 2026",
      shortDate: "09.08.2026",
    },
    nav: {
      story: "Unsere Geschichte",
      family: "Mit uns, neben uns",
      program: "Programm",
      venue: "Location",
      dressCode: "Dresscode",
      rsvp: "Deine Daten",
    },
    audio: {
      play: "Musik abspielen",
      pause: "Musik anhalten",
    },
    envelope: {
      title: "Natanael & Raluka",
      hint: "Einladung öffnen",
      date: "09 · 08 · 2026",
    },
    curtain: {
      hint: "Vorhang öffnen",
    },
    hero: {
      overline: "Wir heiraten",
      subtitle: "Vereint vor Gott und den Menschen, die wir lieben",
      location: "The Barn · Cluj",
      scroll: "Scrollen",
    },
    countdown: {
      title: "Der Countdown",
      subtitle: "In freudiger Erwartung",
      days: "Tage",
      hours: "Stunden",
      minutes: "Minuten",
      seconds: "Sekunden",
      ended: "Es ist soweit!",
    },
    story: {
      overline: "Unsere Geschichte",
      title: "Zwei Herzen, ein Weg",
      body:
        "Eine schöne Liebesgeschichte verdient einen unvergesslichen Tag. Und wenn die Liebe die liebsten Menschen an einem Tisch versammeln könnte, wärt ihr dabei. Deshalb haben wir mit Freude einen Platz für euch reserviert, um einen Tag voller Lächeln, Tränen der Freude und Augenblicke zu teilen, die so schön sind, dass man sie ein wenig länger festhalten möchte.",
      videoCaption: "Wir, heute",
    },
    program: {
      overline: "Das Programm",
      title: "Der Tag des Ja-Worts",
      ceremony: {
        time: "13:00",
        title: "Kirchliche Trauung",
      },
      party: {
        time: "15:00",
        title: "Empfang",
      },
    },
    venue: {
      overline: "Wo",
      title: "The Barn",
      address: "Gheorghieni, Nr. 530, Gem. Feleacu, Bezirk Cluj",
      cta: "In Maps öffnen",
    },
    dressCode: {
      overline: "Dresscode",
      title: "Töne von Rot, Braun und Schwarz",
      swatches: {
        burgundy: "Rot",
        brown: "Braun",
        black: "Schwarz",
      },
    },
    family: {
      overline: "Mit uns, neben uns",
      title: "",
      groomParents: "Eltern des Bräutigams",
      brideParents: "Eltern der Braut",
      witnesses: "Die Trauzeugen",
    },
    attention: {
      overline: "Achtung",
      title: "Achtung!",
      body:
        "Die Teilnahme an dieser Veranstaltung kann Lächeln, Umarmungen und Erinnerungen hervorrufen, die für immer im Herzen bleiben.",
    },
    rsvp: {
      overline: "Deine Daten",
      title: "Deine Zusage",
      subtitle:
        "Bitte bestätige bis zum 9. Juli 2026: jedes Detail hilft uns, gut für dich zu sorgen.",
      step: "Schritt",
      of: "von",
      next: "Weiter",
      back: "Zurück",
      submit: "Zusage senden",
      submitting: "Wird gesendet...",
      attending: {
        title: "Bist du dabei?",
        yes: "Ja, ich komme mit Freude",
        no: "Leider kann ich nicht",
      },
      menu: {
        vegetarian: "Vegetarisch",
        vegan: "Vegan",
      },
      allergies: {
        label: "Allergien oder Unverträglichkeiten",
        placeholder: "Sag uns alles, was wir wissen sollten",
        none: "Keine Allergien",
      },
      accommodation: {
        title: "Brauchst du eine Unterkunft?",
        yes: "Ja, das wäre hilfreich",
        no: "Nein, danke",
      },
      adults: {
        title: "Erwachsene",
        subtitle:
          "Für jeden: Name, Menüauswahl und eventuelle Allergien",
        add: "Erwachsenen hinzufügen",
        firstName: "Vorname",
        lastName: "Nachname",
        remove: "Entfernen",
        person: "Erwachsener",
      },
      children: {
        title: "Kinder",
        subtitle:
          "Falls dabei: Name, Menüauswahl und eventuelle Allergien",
        add: "Kind hinzufügen",
        person: "Kind",
      },
      song: {
        title: "Ein Lied von dir gewählt",
        subtitle: "Wir würden es gern in die Playlist des Abends aufnehmen",
        placeholder:
          "Jedes Fest hat seine Musik, doch unsere wird mit ein paar von euch gewählten Tönen noch schöner klingen",
      },
      contact: {
        title: "Wie können wir dich erreichen",
        hint: "Gib uns mindestens E-Mail oder Handynummer",
        email: "E-Mail",
        phone: "Handy",
      },
      success: {
        title: "Von Herzen Danke",
        body: "Wir haben deine Zusage erhalten. Wir freuen uns, mit dir zu feiern.",
        again: "Eine weitere Antwort senden",
      },
      errors: {
        required: "Pflichtfeld",
        email: "Gib eine gültige E-Mail ein",
        emailOrPhone: "Gib mindestens deine E-Mail oder Handynummer ein, damit wir dich bei Bedarf erreichen können",
        needName: "Gib mindestens einen Erwachsenen mit Vor- und Nachname ein",
        generic: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      },
    },
    footer: {
      title: "Natanael & Raluka",
      date: "09. August 2026 · The Barn, Cluj",
      made: "Mit Liebe",
      download: "Einladung herunterladen",
      downloading: "Wird vorbereitet...",
    },
    admin: {
      title: "Adminbereich",
      subtitle: "RSVP-Zusagen ansehen",
      tokenLabel: "Admin-Token",
      enter: "Eintreten",
      logout: "Abmelden",
      wrong: "Ungültiger Token",
      stats: {
        total: "Zusagen gesamt",
        attending: "Kommen",
        notAttending: "Kommen nicht",
        adults: "Erwachsene",
        children: "Kinder",
        accommodation: "Unterkunft",
        vegan: "Vegan",
        vegetarian: "Vegetarisch",
      },
      table: {
        name: "Name",
        email: "E-Mail",
        phone: "Handy",
        attending: "Anwesenheit",
        adults: "Erwachsene",
        children: "Kinder",
        accommodation: "Unterkunft",
        song: "Lied",
        date: "Sendedatum",
        actions: "Aktionen",
      },
      view: {
        confirmations: "Zusagen",
        trash: "Papierkorb",
      },
      actions: {
        delete: "In den Papierkorb",
        restore: "Wiederherstellen",
        permanentDelete: "Endgültig löschen",
        confirmDelete: "Diese Zusage in den Papierkorb verschieben?",
        confirmPermanentDelete: "Diese Zusage ENDGÜLTIG löschen? Sie kann nicht wiederhergestellt werden.",
      },
      trashEmpty: "Der Papierkorb ist leer",
      deletedAt: "Gelöscht am",
    },
  },
};
